import { HealthResponse } from "@scheduleassist/shared";
import { config } from "./config.js";

export async function getHealth(): Promise<HealthResponse> {
  const res = await fetch(`${config.API_URL}/health`);
  if (!res.ok) throw new Error(`health: ${res.status}`);
  return HealthResponse.parse(await res.json());
}
